/**
 * Helpers for creating a ride from imported documents.
 *
 * Kept free of Vue/Vuex so they can be unit tested with plain node
 * (tests/unit/documentImportCreateRide.test.js).
 */

const { toBackendDate } = require('./documentImportDates');

/**
 * The body posted to setRideInformation when the import creates a ride.
 * Ages are not asked on the import, so they stay 0; the ride manager can set
 * them later from the ride's edit page.
 */
function buildImportRidePayload({
  rideName, rideStartDate, rideEndDate, rideSummary, rideLanguage, isPublic, isSubdomain,
}) {
  return {
    title: rideName,
    checkIn: toBackendDate(rideStartDate),
    checkOut: toBackendDate(rideEndDate),
    text: rideSummary,
    photos_albom_link: '',
    number_of_adult: 0,
    number_of_teen: 0,
    number_of_child: 0,
    physical_disabilities: 'false',
    is_publick: String(!!isPublic),
    is_subdomain: String(!!isSubdomain),
    language: rideLanguage,
  };
}

/**
 * Where to land after the ride is created. Mirrors the manual form: a first
 * ride (the user came from the Start page) goes to onboarding.
 */
function createdRidePath(rideId, isFirstRide) {
  return isFirstRide === true
    ? '/after-first-ride/' + rideId
    : '/single_ride_with_map/' + rideId;
}

/** The import page's starting choices, matching the manual form's defaults. */
function defaultImportRideSettings({ uiLanguage, isUserSubdomainManager }) {
  return {
    rideLanguage: uiLanguage === 'en' ? 'english' : 'hebrew',
    isPublic: false,
    isSubdomain: !!isUserSubdomainManager,
  };
}

/** What the store goes back to once an import is done. */
function resetImportRideSettings() {
  return { rideLanguage: 'hebrew', isPublic: false, isSubdomain: false };
}

module.exports = {
  buildImportRidePayload,
  createdRidePath,
  defaultImportRideSettings,
  resetImportRideSettings,
};
